import { resolveComponent as o, openBlock as r, createElementBlock as t, createVNode as c } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
import { P as s } from "./PreloaderIcon-b44be854.js";
const a = {
  components: {
    PreloaderIcon: s
  }
}, l = { class: "w-full h-full flex items-center justify-center" };
function m(p, _, f, d, i, u) {
  const e = o("PreloaderIcon");
  return r(), t("div", l, [
    c(e, { class: "text-cart-400 w-12 h-12 flex items-center" })
  ]);
}
const $ = /* @__PURE__ */ n(a, [["render", m]]);
export {
  $ as C
};
